export default __webpack_public_path__ + "static/media/8830f0d659da3619fc486d51d303aedb.jpg";